import { render, staticRenderFns } from "./ProposalDetails.vue?vue&type=template&id=06e5e794&scoped=true&"
import script from "./ProposalDetails.vue?vue&type=script&lang=js&"
export * from "./ProposalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetails.vue?vue&type=style&index=0&id=06e5e794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5e794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e5e794')) {
      api.createRecord('06e5e794', component.options)
    } else {
      api.reload('06e5e794', component.options)
    }
    module.hot.accept("./ProposalDetails.vue?vue&type=template&id=06e5e794&scoped=true&", function () {
      api.rerender('06e5e794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/ProposalDetails.vue"
export default component.exports